<template>
  <div>
    <div class="main-content">
      <div class="main-content-inner">
        <div class="breadcrumbs ace-save-state" id="breadcrumbs">
          <ul class="breadcrumb">
            <li>
              <i class="ace-icon fa fa-home home-icon"></i>
              <a href="#/">ダッシュボード</a>
            </li>
            <router-link tag="li" :to="{ name: 'gates'}">
              <a>ゲート一覧</a>
            </router-link>
            <li class="active">新規ゲート登録</li>
          </ul><!-- /.breadcrumb -->
        </div>
        <div class="page-header">
          <div class="checkbox">
            <h3>新規ゲート登録</h3>
          </div>
        </div><!-- /.page-header -->
        <div class="page-content detail-gate-edit">
          <div id="loading" v-if="loading"><div class="loadingMsg"></div></div>
          <div class="tab-content">
          <div class="alert alert-success" v-if="message_success">
            {{ message_success }}
          </div>
          <div class="alert alert-danger" v-if="message_error">
            {{ message_error }}
          </div>
          <div class="row">
            <div class="col-xs-12">
              <!-- PAGE CONTENT BEGINS -->
              <form class="form-horizontal" role="form">
              <div class="row">
              <div class="col-xs-6">
                <div class="row">
                <div class="profile-user-info profile-user-info-striped">
                  <div class="profile-info-row">
                    <div class="profile-info-name">製品ID</div>
                    <div class="profile-info-value">
                      <span>{{gateInfor.gateModelId}}</span>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">製品名</div>
                    <div class="profile-info-value">
                      <span id="product_error" class="error_m"></span>
                      <select id="productname" class="form-control" data-placeholder="製品名選択" v-model="gateInfor.gateModelId" @change="getGateModelInforWithGateModeId(gateInfor.gateModelId)">
                        <option v-for="(item, index) in listGateModel" v-bind:value="item.gateModelId" v-bind:key="index">
                          {{item.gateModelName}}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">型番</div>
                    <div class="profile-info-value">
                      <span>{{gateInfor.gateModelCode}}</span>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">アイコンタイプ</div>
                    <div class="profile-info-value">
                      <select class="form-control" v-model="gateInfor.iconType">
                        <option v-for="item in listIconType" v-bind:value="item.value" v-bind:key="item.value">
                          {{item.text}}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="profile-info-row" v-if="gateInfor.customizable && checkShowHide(gateInfor.makerCode)">
                    <div class="profile-info-name">ターゲット動作設定Time</div>
                    <div class="profile-info-value">
                      <input type="number" min="0" max="10000" class="form-control input-sm" v-model="gateInfor.controlTime">
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">ゲート名</div>
                    <div class="profile-info-value">
                      <span id="gate_error" class="error_m"></span>
                      <input type="text" class="form-control input-sm" id="gatename" v-model="gateInfor.gateName">
                    </div>
                  </div>
                  <div class="profile-info-row" v-if="checkShowHide(gateInfor.makerCode)">
                    <div class="profile-info-name">ゲート動作モード</div>
                    <div class="profile-info-value">
                      <select class="form-control" v-model="gateInfor.isVisitor">
                        <option v-for="item in listIsVisitor" v-bind:value="item.value" v-bind:key="item.value">
                          {{item.text}}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="profile-info-row" v-if="checkShowHide(gateInfor.makerCode)">
                    <div class="profile-info-name">NFCの有効</div>
                    <div class="profile-info-value">
                      <input name="switch-field-1" class="ace ace-switch ace-switch-4" type="checkbox" v-model="gateInfor.isNFCValid">
                      <span class="lbl"></span>
                    </div>
                  </div>
                  <div class="profile-info-row" v-if="checkShowHide(gateInfor.makerCode)">
                    <div class="profile-info-name">テンキーの有効・無効</div>
                    <div class="profile-info-value">
                      <input name="switch-field-1" class="ace ace-switch ace-switch-4" type="checkbox" v-model="gateInfor.isTenKeyValid">
                      <span class="lbl"></span>
                    </div>
                  </div>
                  <div class="profile-info-row" v-if="checkShowHide(gateInfor.makerCode)">
                    <div class="profile-info-name">ゲートパスワードの有効・無効</div>
                    <div class="profile-info-value">
                      <input name="switch-field-1" class="ace ace-switch ace-switch-4" type="checkbox" v-model="gateInfor.isGatePasswordValid" :disabled="gateInfor.isVisitor">
                      <span class="lbl"></span>
                    </div>
                  </div>
                  <div class="profile-info-row" v-if="checkShowHide(gateInfor.makerCode)">
                    <div class="profile-info-name">ゲートパスワードの桁数</div>
                    <div class="profile-info-value">
                      <select class="form-control" v-model="gateInfor.gatePasswordLength" :disabled="getEditStatus()">
                        <option v-for="item in listPassLenght" v-bind:value="item.value" v-bind:key="item.value">
                          {{item.text}}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="profile-info-row" v-if="checkShowHide(gateInfor.makerCode)">
                    <div class="profile-info-name">ゲートパスワードのseed値</div>
                    <div class="profile-info-value">
                      <span id="passwordseed_error" class="error_m"></span>
                      <input type="text" class="form-control input-sm" id="pseed" v-model="gateInfor.gatePasswordSeed" style="text-transform:uppercase" :disabled="getEditStatus()">
                    </div>
                  </div>
                </div>
                </div>
              </div>
              <div class="col-xs-6">
                <div class="row">
                  <div class="profile-user-info profile-user-info-striped">
                    <div class="profile-info-row">
                      <div class="profile-info-name">2段階認証の有効・無効</div>
                      <div class="profile-info-value">
                        <input name="switch-field-1" class="ace ace-switch ace-switch-4" type="checkbox" v-model="gateInfor.isTwoStepAuthValid" :disabled="gateInfor.isVisitor">
                        <span class="lbl"></span>
                      </div>
                    </div>
                    <div class="profile-info-row">
                      <div class="profile-info-name">BLE出力設定</div>
                      <div class="profile-info-value">
                        <select class="form-control" v-model="gateInfor.bleIntensity" v-if="gateInfor.makerCode === 2">
                          <option v-for="item in listBleIntensityForWafer" v-bind:value="item.value" v-bind:key="item.value">
                            {{item.text}}
                          </option>
                        </select>
                        <select class="form-control" v-model="gateInfor.bleIntensity" v-else>
                          <option v-for="item in listBleIntensity" v-bind:value="item.value" v-bind:key="item.value">
                            {{item.text}}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="profile-info-row" v-if="checkShowHide(gateInfor.makerCode)">
                      <div class="profile-info-name">ブザー鳴動設定</div>
                      <div class="profile-info-value">
                        <select class="form-control" v-model="gateInfor.buzzerPattern">
                          <option v-for="item in listBuzzerPattern" v-bind:value="item.value" v-bind:key="item.value">
                            {{item.text}}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="profile-info-row">
                      <div class="profile-info-name">備考.1</div>
                      <div class="profile-info-value">
                        <span id="option1_error" class="error_m"></span>
                        <textarea class="form-control" id="option1" placeholder="備考.1" v-model="gateInfor.option1"></textarea>
                      </div>
                    </div>
                    <div class="profile-info-row">
                      <div class="profile-info-name">備考.2</div>
                      <div class="profile-info-value">
                        <span id="option2_error" class="error_m"></span>
                        <textarea class="form-control" id="option1" placeholder="備考.2" v-model="gateInfor.option2"></textarea>
                      </div>
                    </div>
                    <div class="profile-info-row">
                      <div class="profile-info-name">ステータス</div>
                      <div class="profile-info-value">
                        <input name="switch-field-1" class="ace ace-switch ace-switch-4" type="checkbox" v-model="gateInfor.isValid">
                        <span class="lbl"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              </div>
              <div class="form-group">
                <div class="col-sm-12 text-align-right">
                  <router-link :to="{ name: 'gates'}" class="btn cancel_bottom">
                    キャンセル
                  </router-link>
                  <button class="btn btn-info save_group_bottom" type="button" @click="validateBeforeSubmit">
                    保存
                  </button>
                </div>
              </div>
              </form>
              <!-- PAGE CONTENT ENDS -->
            </div><!-- /.col -->
          </div><!-- /.row -->
          </div>
        </div><!-- /.page-content -->
      </div>
    </div><!-- /.main-content -->
  </div>
</template>

<script>
import * as Config from '../../config'
import moment from 'moment'

export default {
  data () {
    return {
      errorMessageLogs: '',
      selectedUserId: [],
      selectedGateId: [],
      listUserGroup: null,
      listGateGroup: null,
      listIconType: [
        { text: 'その他', value: 0 },
        { text: 'ドア', value: 1 },
        { text: 'ロッカー', value: 2 }
      ],
      listControlTime: [
        { text: '0000－9999 S', value: 0 },
        { text: '000.0-999.9 S', value: 1 },
        { text: '00.00-99.99 S', value: 2 },
        { text: '0.000-9.999 S', value: 3 }
      ],
      listIsVisitor: [
        { text: 'ビジター', value: true },
        { text: 'メンバー', value: false }
      ],
      listBuzzerPattern: [
        { text: 'OFF', value: 0 },
        { text: '鳴動パターン１', value: 1 },
        { text: '鳴動パターン２', value: 2 }
      ],
      listPassLenght: [
        { text: '5桁', value: 5 },
        { text: '6桁', value: 6 },
        { text: '7桁', value: 7 },
        { text: '8桁', value: 8 }
      ],
      listBleIntensity: [
        { text: '4dBm', value: 0 },
        { text: '0dBm', value: 1 },
        { text: '-4dBm', value: 2 },
        { text: '-8dBm', value: 3 },
        { text: '-12dBm', value: 4 },
        { text: '-16dBm', value: 5 },
        { text: '-20dBm', value: 6 },
        { text: '-40dBm', value: 7 }
      ],
      listBleIntensityForWafer: [
        { text: '0dBm', value: 1 },
        { text: '-4dBm', value: 2 },
        { text: '-8dBm', value: 3 },
        { text: '-12dBm', value: 4 },
        { text: '-16dBm', value: 5 },
        { text: '-20dBm', value: 6 }
      ],
      gateInfor: {
        gateId: '',
        gateModelCode: '',
        gateModelName: '',
        gateModelId: '',
        iconType: 0,
        makerCode: '',
        customizable: false,
        target: 0,
        controlTime: 0,
        timeUnit: 0,
        gateName: '',
        isVisitor: false,
        isNFCValid: true,
        isTenKeyValid: true,
        isGatePasswordValid: false,
        gatePasswordLength: 5,
        gatePasswordSeed: '',
        isTwoStepAuthValid: false,
        bleIntensity: 4,
        buzzerPattern: 1,
        option1: '',
        option2: '',
        gateSNMain: '',
        gateSNBLE: '',
        gateFWMain: '',
        gateFWBLE: '',
        registered: '',
        updated: '',
        reported: '',
        revisionDesired: '',
        revisionReported: '',
        voltage: '',
        scanDate: '',
        isValid: true
      },
      gateId: '',
      flag: 0,
      message_success: '',
      message_error: '',
      isDisabled: false,
      progress: 0,
      success: false,
      loading: false,
      errorMessage: [],
      successUser: 0,
      successGate: 0,
      errorName: '',
      countUser: 0,
      countGate: 0,
      listGateModel: null
    }
  },
  watch: {
    'gateInfor.isVisitor': 'changeValue'
  },
  created () {
    var vm = this
    vm.getListGateModel()
  },
  methods: {
    checkShowHide (makerCode) {
      if (makerCode === 2) {
        return false
      } else {
        return true
      }
    },
    changeValue () {
      if (this.gateInfor.isVisitor) {
        this.gateInfor.isGatePasswordValid = false
        this.gateInfor.isTwoStepAuthValid = false
      }
    },
    getEditStatus () {
      if (!this.gateInfor.isGatePasswordValid || this.gateInfor.isVisitor) {
        return true
      } else {
        return false
      }
    },
    validateBeforeSubmit () {
      this.flag = 0
      if (this.gateInfor.gateModelId === null || this.gateInfor.gateModelId === '') {
        $('#product_error').html('製品名は必須です。')
        $('#productname').addClass('error')
        this.flag += 1
      } else {
        $('#product_error').html('')
        $('#productname').removeClass('error')
      }
      if (this.gateInfor.gateName === null || this.gateInfor.gateName === '') {
        $('#gate_error').html('ゲート名は必須です。')
        $('#gatename').addClass('error')
        this.flag += 1
      } else if (this.gateInfor.gateName.length > 64) {
        $('#gate_error').html('ゲート名は64文字以内で入力してください。')
        $('#gatename').addClass('error')
        this.flag += 1
      } else {
        $('#gate_error').html('')
        $('#gatename').removeClass('error')
      }
      if (this.gateInfor.option1.length > 64) {
        $('#option1_error').html('備考.1は64文字以内で入力してください。')
        this.flag += 1
      } else {
        $('#option1_error').html('')
      }
      if (this.gateInfor.option2.length > 64) {
        $('#option2_error').html('備考.2は64文字以内で入力してください。')
        this.flag += 1
      } else {
        $('#option2_error').html('')
      }
      if (this.gateInfor.isGatePasswordValid && this.gateInfor.gatePasswordSeed.length > 0) {
        var isOk = /^[0-9A-F]+$/.test(this.gateInfor.gatePasswordSeed)
        if (!isOk || this.gateInfor.gatePasswordSeed.length > 18 || this.gateInfor.gatePasswordSeed.length < 18) {
          $('#passwordseed_error').html('半角英数（0～9、A〜F）で18文字入力してください。')
          $('#pseed').addClass('error')
          this.flag += 1
        } else {
          $('#passwordseed_error').html('')
          $('#pseed').removeClass('error')
          this.flag = 0
        }
      }
      if (this.flag === 0) {
        this.editInforGate()
      }
    },
    converDate (t) {
      return moment(new Date(t * 1000)).format('YYYY/MM/DD H:mm')
    },
    getListGateModel () {
      this.$http.get(Config.GATE_MODEL_LIST_API)
        .then(response => {
          console.log(response)
          this.listGateModel = response.body.gateModels
        })
        .catch((error) => {
          this.listGateModel = null
          console.log(error)
        })
    },
    getGateModelInforWithGateModeId (gateModelId) {
      var vm = this
      vm.listGateModel.forEach(function (item) {
        if (item.gateModelId === gateModelId) {
          vm.gateInfor.gateModelCode = item.gateModelCode
          vm.gateInfor.gateModelName = item.gateModelName
          vm.gateInfor.controlTime = item.controlTime
          vm.gateInfor.makerCode = item.makerCode
          vm.gateInfor.customizable = item.customizable
          vm.gateInfor.iconType = item.iconType
          vm.gateInfor.target = item.target
          vm.gateInfor.timeUnit = item.timeUnit
        }
      })
    },
    reset () {
      this.gateInfor.gateName = ''
      this.gateInfor.gateModelCode = ''
      this.gateInfor.gateModelId = ''
      this.gateInfor.isVisitor = false
      this.gateInfor.isNFCValid = true
      this.gateInfor.isTenKeyValid = true
      this.gateInfor.isGatePasswordValid = false
      this.gateInfor.isTwoStepAuthValid = false
      this.gateInfor.bleIntensity = 4
      this.gateInfor.buzzerPattern = 1
      this.gateInfor.isValid = true
      this.gateInfor.gatePasswordSeed = ''
      this.gateInfor.option1 = ''
      this.gateInfor.option2 = ''
    },
    editInforGate () {
      var vm = this
      vm.loading = true
      const Infor = {
        gateName: vm.gateInfor.gateName,
        gateModelId: vm.gateInfor.gateModelId,
        gateModelName: vm.gateInfor.gateModelName,
        gateModelCode: vm.gateInfor.gateModelCode,
        iconType: vm.gateInfor.iconType,
        makerCode: vm.gateInfor.makerCode,
        customizable: vm.gateInfor.customizable,
        target: vm.gateInfor.target,
        timeUnit: vm.gateInfor.timeUnit,
        controlTime: parseInt(vm.gateInfor.controlTime),
        isVisitor: vm.gateInfor.isVisitor,
        isNFCValid: vm.gateInfor.isNFCValid,
        isTenKeyValid: vm.gateInfor.isTenKeyValid,
        isGatePasswordValid: vm.gateInfor.isGatePasswordValid,
        isTwoStepAuthValid: vm.gateInfor.isTwoStepAuthValid,
        bleIntensity: vm.gateInfor.bleIntensity,
        buzzerPattern: vm.gateInfor.buzzerPattern,
        option1: vm.gateInfor.option1,
        option2: vm.gateInfor.option2,
        isValid: vm.gateInfor.isValid
      }
      if (vm.gateInfor.isGatePasswordValid) {
        Infor.gatePasswordLength = vm.gateInfor.gatePasswordLength
        if (vm.gateInfor.gatePasswordSeed.length > 0) {
          Infor.gatePasswordSeed = vm.gateInfor.gatePasswordSeed
        }
      }
      console.log(Infor)
      this.$http.post(Config.GATES_LIST_API, Infor)
        .then(response => {
          this.reset()
          this.loading = false
          this.message_success = Config.ADD_GATE_API_SUCCESS
          this.message_error = ''
        })
        .catch((error) => {
          this.loading = false
          this.message_success = ''
          switch (error.status) {
            case 400:
              this.message_error = '入力したパラメーターが誤っています。入力内容をご確認ください。'
              break
            case 403:
              this.message_error = 'ゲートの追加権限がありません。'
              break
            case 409:
              this.message_error = '入力されたゲート名は既に使用されています。他のゲート名を入力してください。'
              break
            case 500:
              this.message_error = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            case 503:
              this.message_error = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            default:
              this.message_error = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              break
          }
        })
    }
  }
}
</script>
<style>
.detail-gate-edit .profile-info-name{
  width: 400px
}
.float-left{
    float: left;
    padding-left: 12px
  }
  .btn-cus{
    padding: 10px 15px;
    color: #fff
  }
  .btn-right{
    float: right;
  }
  .btn-add,.btn-add:hover{
    background: #007F41!important
  }
  a.btn-delete,a.btn-delete:hover{
    background: #000!important;
    border-color: #000!important;
    color: #fff!important;
    margin-right: 10px;
    text-decoration: none;
  }
  .form-horizontal .control-label{
    margin-top: 0px
  }
  .col-custom{
    padding-right: 0px!important;
  }
  .iValid{
    padding-top: 2px!important;
  }
  input[type=checkbox].ace.ace-switch+.lbl::before{
    text-indent: 25px!important;
    content: "無効"!important;
  }
  input[type=checkbox].ace.ace-switch:checked+.lbl::before{
    text-indent: 5px!important;
    content: "有効"!important;
  }
  .message{
    position: absolute;
  }
  .form-horizontal .control-label{
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/views/gate/GateAdd.vue